import { type BaseItem, type Nullable, type NullablePartial } from './common.js';
import { type RpaJobEvent } from './rpaEvent.js';

export enum Ehr {
  Athena = 'ATHENA',
  AthenaIDXGroupManagement = 'ATHENAIDX_GROUPMANAGEMENT',
  AthenaIDXWeb = 'ATHENAIDX_WEB',
  AthenaWeb = 'ATHENA_WEB',
  Availity = 'AVAILITY',
  BcbsmsMedicalNecessity = 'BCBSMS_MEDICAL_NECESSITY',
  Bcbsri = 'BCBSRI',
  Cerner = 'CERNER',
  Cohere = 'COHERE',
  Epic = 'EPIC',
  Evicore = 'EVICORE',
  ExternalAPI = 'EXTERNAL_API',
  Fhir = 'FHIR',
  HealthHelp = 'HEALTH_HELP',
  HL7 = 'HL7',
  Intergy = 'INTERGY',
  Meditech = 'MEDITECH',
  MedSolutions = 'MEDSOLUTIONS',
  MHK = 'MHK',
  OnBase = 'ON_BASE',
  Other = 'OTHER',
  RadMD = 'RADMD',
  Revcycle = 'REVCYCLE',
  Schapptbook = 'SCHAPPTBOOK',
  UnitedHealthcare = 'UNITED_HEALTHCARE',
  Win32 = 'WIN32',
}

export enum Kind {
  CalendarSync = 'CALENDAR_SYNC',
  ExportAllergies = 'EXPORT_ALLERGIES',
  ExportAppointmentNote = 'EXPORT_APPOINTMENT_NOTE',
  ExportAppointmentStatus = 'EXPORT_APPOINTMENT_STATUS',
  ExportAuthorizationForm = 'EXPORT_AUTHORIZATION_FORM',
  ExportAuthorizationStart = 'EXPORT_AUTHORIZATION_START',
  ExportAuthorizationStatus = 'EXPORT_AUTHORIZATION_STATUS',
  ExportAuthorizationStatusV2 = 'EXPORT_AUTHORIZATION_STATUS_V2',
  ExportAuthorizationSubmission = 'EXPORT_AUTHORIZATION_SUBMISSION',
  ExportBilling = 'EXPORT_BILLING',
  ExportBillingGroup = 'EXPORT_BILLING_GROUP',
  ExportCareGapFindings = 'EXPORT_CARE_GAP_FINDINGS',
  ExportClinicalComment = 'EXPORT_CLINICAL_COMMENT',
  ExportDummyValues = 'EXPORT_DUMMY_VALUES',
  ExportNewEncounter = 'EXPORT_NEW_ENCOUNTER',
  ExportEncounterInformation = 'EXPORT_ENCOUNTER_INFORMATION',
  ExportEncounterPatientData = 'EXPORT_ENCOUNTER_PATIENT_DATA',
  ExportFinancialResponsibility = 'EXPORT_FINANCIAL_RESPONSIBILITY',
  ExportFamilyMedicalHistory = 'EXPORT_FAMILY_MEDICAL_HISTORY',
  ExportFindingEvidence = 'EXPORT_FINDING_EVIDENCE',
  ExportFollowUp = 'EXPORT_FOLLOW_UP',
  ExportFormOutcomes = 'EXPORT_FORM_OUTCOMES',
  ExportForms = 'EXPORT_FORMS',
  ExportGeneralComment = 'EXPORT_GENERAL_COMMENT',
  ExportGuarantors = 'EXPORT_GUARANTORS',
  ExportHccFindings = 'EXPORT_HCC_FINDINGS',
  ExportHospitalAccount = 'EXPORT_HOSPITAL_ACCOUNT',
  ExportMarkAsReviewed = 'EXPORT_MARK_AS_REVIEWED',
  ExportMedications = 'EXPORT_MEDICATIONS',
  ExportMspqForm = 'EXPORT_MSPQ_FORM',
  ExportNote = 'EXPORT_NOTE',
  ExportNoteCheckedIn = 'EXPORT_NOTE_CHECKED_IN',
  ExportNoticeOfAdmission = 'EXPORT_NOTICE_OF_ADMISSION',
  ExportNoticeOfAdmissionStatus = 'EXPORT_NOTICE_OF_ADMISSION_STATUS',
  ExportOrders = 'EXPORT_ORDERS',
  ExportPatientCareProviders = 'EXPORT_PATIENT_CARE_PROVIDERS',
  ExportPatientInformation = 'EXPORT_PATIENT_INFORMATION',
  ExportPatientInsuranceInformation = 'EXPORT_PATIENT_INSURANCE_INFORMATION',
  ExportPatientMedicalHistory = 'EXPORT_PATIENT_MEDICAL_HISTORY',
  ExportPatientOutreaches = 'EXPORT_PATIENT_OUTREACHES',
  ExportPatientPharmacies = 'EXPORT_PATIENT_PHARMACIES',
  ExportPatientUploads = 'EXPORT_PATIENT_UPLOADS',
  ExportPatientUploadStatuses = 'EXPORT_PATIENT_UPLOAD_STATUSES',
  ExportPayorAuthorization = 'EXPORT_PAYOR_AUTHORIZATION',
  ExportPrenatalFlowsheet = 'EXPORT_PRENATAL_FLOWSHEET',
  ExportPrevisitPlanning = 'EXPORT_PREVISIT_PLANNING',
  ExportProcessedPayments = 'EXPORT_PROCESSED_PAYMENTS',
  ExportProcessedRefunds = 'EXPORT_PROCESSED_REFUNDS',
  ExportQualityMeasures = 'EXPORT_QUALITY_MEASURES',
  ExportReferralDocument = 'EXPORT_REFERRAL_DOCUMENT',
  ExportReferralOrder = 'EXPORT_REFERRAL_ORDER',
  ExportRegistrationNote = 'EXPORT_REGISTRATION_NOTE',
  ExportOrderRequestListStatus = 'EXPORT_ORDER_REQUEST_LIST_STATUS',
  ExportReviewClinicalAdvisories = 'EXPORT_REVIEW_CLINICAL_ADVISORIES',
  ExportScheduledAppointment = 'EXPORT_SCHEDULED_APPOINTMENT',
  ExportScheduledOrderAssociation = 'EXPORT_SCHEDULED_ORDER_ASSOCIATION',
  ExportSocialHistory = 'EXPORT_SOCIAL_HISTORY',
  ExportSurgicalHistory = 'EXPORT_SURGICAL_HISTORY',
  ExportTerminatedInsurances = 'EXPORT_TERMINATED_INSURANCES',
  ExportVerifyRegistration = 'EXPORT_VERIFY_REGISTRATION',
  ExtractAllergies = 'EXTRACT_ALLERGIES',
  ExtractAuthorizationStatus = 'EXTRACT_AUTHORIZATION_STATUS',
  ExtractBilling = 'EXTRACT_BILLING',
  ExtractCareGapFindings = 'EXTRACT_CARE_GAP_FINDINGS',
  ExtractCareGapStatuses = 'EXTRACT_CARE_GAP_STATUSES',
  ExtractCarryCurrent = 'EXTRACT_CARRY_CURRENT',
  ExtractCarryForward = 'EXTRACT_CARRY_FORWARD',
  ExtractDiagmedProblemGroups = 'EXTRACT_DIAGMED_PROBLEM_GROUPS',
  ExtractEncounterInformation = 'EXTRACT_ENCOUNTER_INFORMATION',
  ExtractEncounterPatientData = 'EXTRACT_ENCOUNTER_PATIENT_DATA',
  ExtractFamilyMedicalHistory = 'EXTRACT_FAMILY_MEDICAL_HISTORY',
  ExtractGuarantors = 'EXTRACT_GUARANTORS',
  ExtractHistoricalPatientEncounters = 'EXTRACT_HISTORICAL_PATIENT_ENCOUNTERS',
  ExtractImmunizationRegistry = 'EXTRACT_IMMUNIZATION_REGISTRY',
  ExtractInterpretations = 'EXTRACT_INTERPRETATIONS',
  ExtractLabValues = 'EXTRACT_LAB_VALUES',
  ExtractMedicalNecessity = 'EXTRACT_MEDICAL_NECESSITY',
  ExtractMedications = 'EXTRACT_MEDICATIONS',
  ExtractMspqForm = 'EXTRACT_MSPQ_FORM',
  ExtractNoticeOfAdmissionStatus = 'EXTRACT_NOTICE_OF_ADMISSION_STATUS',
  ExtractOrders = 'EXTRACT_ORDERS',
  ExtractOutstandingBalances = 'EXTRACT_OUTSTANDING_BALANCES',
  ExtractPatientAdvisories = 'EXTRACT_PATIENT_ADVISORIES',
  ExtractPatientAdvisoryDocuments = 'EXTRACT_PATIENT_ADVISORY_DOCUMENTS',
  ExtractPatientCareProviders = 'EXTRACT_PATIENT_CARE_PROVIDERS',
  ExtractPatientCommunicationConsent = 'EXTRACT_PATIENT_COMMUNICATION_CONSENT',
  ExtractPatientDocuments = 'EXTRACT_PATIENT_DOCUMENTS',
  ExtractPatientEligibility = 'EXTRACT_PATIENT_ELIGIBILITY',
  ExtractPatientInformation = 'EXTRACT_PATIENT_INFORMATION',
  ExtractPatientInsuranceRteInformation = 'EXTRACT_PATIENT_INSURANCE_RTE_INFORMATION',
  ExtractPatientMedicalHistory = 'EXTRACT_PATIENT_MEDICAL_HISTORY',
  ExtractPatientOrder = 'EXTRACT_PATIENT_ORDER',
  ExtractPatientPharmacies = 'EXTRACT_PATIENT_PHARMACIES',
  ExtractPatientProblems = 'EXTRACT_PATIENT_PROBLEMS',
  ExtractPatientUploads = 'EXTRACT_PATIENT_UPLOADS',
  ExtractPayorAuthorizationStatus = 'EXTRACT_PAYOR_AUTHORIZATION_STATUS', // DEPRECATED
  ExtractPredictBillingData = 'EXTRACT_PREDICT_BILLING_DATA',
  ExtractPreferredPharmacy = 'EXTRACT_PREFERRED_PHARMACY',
  ExtractPregnancy = 'EXTRACT_PREGNANCY',
  ExtractQualityMeasures = 'EXTRACT_QUALITY_MEASURES',
  ExtractSocialHistory = 'EXTRACT_SOCIAL_HISTORY',
  ExtractSurgicalHistory = 'EXTRACT_SURGICAL_HISTORY',
  ExtractUpcomingPatientInsurance = 'EXTRACT_UPCOMING_PATIENT_INSURANCE',
  ExtractUpcomingPregnancy = 'EXTRACT_UPCOMING_PREGNANCY',
  ExtractVitals = 'EXTRACT_VITALS',
  OutreachSync = 'OUTREACH_SYNC',
  PatientListSync = 'PATIENT_LIST_SYNC',
  PatientOrdersSync = 'PATIENT_ORDERS_SYNC',
  Reckon = 'RECKON',
}

export enum Source {
  Manual = 'MANUAL',
  Automatic = 'AUTOMATIC',
  Directive = 'DIRECTIVE',
}

type RpaJobRouting = Nullable<{
  practiceId: string;
  encounterId: string;
  ehrInformationId: string;
  feedId: string;
  patientOrderId: string;
}>;

type RpaJobPubsubRouting = Nullable<{
  messageId: string;
}>;

interface BaseRpaJob extends RpaJobRouting, RpaJobPubsubRouting {
  kind: Kind;
  source: Source;
  ehr: string | null;
  workflowId: string | null;
  componentRecognizerVersion: string | null;
  isSuccessful: boolean | null;
  failureReason: string | null;
  completed: string | null;
}

export interface RpaJob extends BaseItem, BaseRpaJob {
  events: RpaJobEvent[];
  copilotEnabled?: boolean;
}

export type FindAllOptions = Partial<NullablePartial<RpaJobRouting> & Pick<BaseRpaJob, 'kind'>>;
